<template>
    <div class="abs loader-info">
        <div class="content-loader-and-info">
            <div class="loader-info-centent-loader">
                <svg
                    version="1.1"
                    id="L3"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 100 100"
                    enable-background="new 0 0 0 0"
                    xml:space="preserve"
                >
                    <radialGradient id="radial-gradient" cx="91.67" cy="52.21" r="36.49" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stop-color="#fff" />
                        <stop offset="1" stop-color="#41b4E8" />
                    </radialGradient>

                    <path
                        class="cls-2"
                        d="M84,46.7C83.1,67.4,66,84,45,84C23.5,84,6,66.5,6,45C6,23.5,23.5,6,45,6c7.4,0,14.3,2.1,20.2,5.6L68,6.3
                C61.3,2.3,53.4,0,45,0C20.2,0,0,20.1,0,45s20.2,45,45,45c24.4,0,44.2-19.4,45-43.5L84,46.7z"
                    >
                        <animateTransform attributeName="transform" dur="1.2s" type="rotate" from="0 45 45" to="360 45 45" repeatCount="indefinite" />
                    </path>
                </svg>
            </div>
            <div v-if="displayInfo">
                <!-- <transition name="fade"> -->
                <img src="./../../assets/tips.png" width="auto" height="150" v-if="show" />
                <!-- </transition> -->
                <!-- <transition name="fade"> -->
                <img src="./../../assets/tips2.png" width="auto" height="150" v-if="!show" />
                <!-- </transition> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        displayInfo: { type: Boolean, default: false }
    },
    data() {
        return {
            show: false
        };
    },
    computed: {},
    created() {},
    mounted() {
        if (this.displayInfo) {
            setInterval(() => {
                this.show = !this.show;
            }, 5000);
        }
    },
    methods: {}
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.loader-info {
    display: flex;
    justify-content: center;
    justify-items: center;
    z-index: 100;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.6);

    .content-loader-and-info {
        height: 500px;
        /*padding-top: 300px;*/
    }

    .loader-info-centent-loader {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

*,
html {
    margin: 0;
    padding: 0;
}

body {
    background: #ffffff;

    text-align: center;

    font-family: "Comfortaa", cursive;
}

svg {
    width: 100px;
    height: 100px;
    margin: 20px;
    display: inline-block;
}

.cls-1 {
    fill: #41b4e8;
}

.cls-2 {
    fill: url(#radial-gradient);
}
</style>



// WEBPACK FOOTER //
// LoaderInfo.vue?0da00778